import { render } from "./NokoriLoginPage.vue?vue&type=template&id=055bdcb8&scoped=true"
import script from "./NokoriLoginPage.vue?vue&type=script&lang=js"
export * from "./NokoriLoginPage.vue?vue&type=script&lang=js"

import "./NokoriLoginPage.vue?vue&type=style&index=0&id=055bdcb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055bdcb8"]])

export default __exports__